import { VideoUtils } from './video-utils';
VideoUtils.redirectIfUnsupported();

import './sentry';
import { WaitingList } from './waiting-list';
import { MeetingsList } from './meetings-list';
import { CreateMeeting } from './create-meeting/create-meeting';
import { VDXCall } from './vdx-call';
import { LogList } from './log-list';
import { TableOfContent } from './table-of-content';
import { JoinWithRoomKey } from './join-with-room-key';

(window as any).Puisa = {
	VDXCall,
	WaitingList,
	MeetingsList,
	CreateMeeting,
	LogList,
	TableOfContent,
	JoinWithRoomKey,
};
